import { IMultiSuggestResult } from '@cian/geosuggest-widget';
import { isNil } from 'ramda';

import { EAddressType, getYandexSuggest } from '../getYandexSuggest';
import { TThunkAction } from '../../../types/redux';
import { IGetGeoSuggestParams } from './types';

export const getByStreets = (params: IGetGeoSuggestParams): TThunkAction<Promise<IMultiSuggestResult>> => {
  return async dispatch => {
    const result = await dispatch(
      getYandexSuggest({
        request: `город ${params.location.name}, ${params.request}`,
        addressType: EAddressType.street,
      }),
    );

    if (isNil(result.suggestions.addresses)) {
      return {
        sortOrder: [],
        suggestions: {},
      };
    }

    return {
      sortOrder: result.sortOrder,
      suggestions: {
        addresses: result.suggestions.addresses.map(suggestion => ({
          ...suggestion,
          value: suggestion.displayName,
        })),
      },
    };
  };
};
